import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateDecimal',
})
export class TruncateDecimalPipe implements PipeTransform {
  transform(value: string | null): string {
    if (value) {
      const number = Number(value);
      const decimalPart = number % 1;
      return decimalPart !== 0
        ? number.toString()
        : Math.floor(number).toString();
    } else {
      return '0';
    }
  }
}
